<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center">
                    <v-col class="text-center">
                        <div class="text-uppercase font-weight-bold primary--text text-h5">
                            Editar cliente
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="5">
                        <v-form ref="form" @submit.prevent="save">
                            <cliente-form :values="form" :rules="rules"></cliente-form>
                        </v-form>
                    </v-col>
                </v-row>

            </div>
			<v-row justify="center">
				<v-col cols="12" md="5" class="text-right">
					<v-btn class="full-width-btn" tile text color="primary" :to="{ name: 'Clientes' }">Cancelar</v-btn>
					<v-btn tile color="secondary" class="ml-md-2  ml-0 mt-md-0 mt-3 full-width-btn text-base-color" @click="save">Guardar</v-btn>
				</v-col>
			</v-row>
            <snackbar :props="snackbarProps"></snackbar>
        </template>
    </contentCard>
</template>

<script>
import ClienteForm from "./Form.vue";
export default {
    components: {
        'cliente-form': ClienteForm,
    },
	data(){
		return {
            id: this.$route.params.id,
            loading: false,
            form: {
                name: '',
                rfc: '',
                business_name: '',
                address_code: '',
                neighborhood: '',
                street: '',
                ext_number: '',
                int_number: '',
                contact: '',
                phone: '',
                email: '',
            },
            rules: {
                name: [
                    v => !!v || 'Nombre es requerido'
                ],
                rfc: [
                    v => (v.length == 0 || (v.length >= 12  && v.length <= 13)) || 'RFC debe contener de 12 a 13 carácteres'
                ],
                business_name: [
                    // v => !!v || 'Razón social es requerido'
                ],
                neighborhood: [
                    // v => !!v || 'Colonia es requerido'
                ],
                street: [
                    // v => !!v || 'Calle es requerido'
                ],
                ext_number: [
                    // v => !!v || 'No. Ext. es requerido',
                    v => /^[0-9]*$/.test(v) || 'No. Ext. sólo debe contener números',
                ],
                int_number: [],
                contact: [
                    v => !!v || 'Contacto es requerido'
                ],
                phone: [
                    v => (v.length == 0 || v.length == 10) || 'Teléfono debe contener 10 digitos',
                    v => /^[0-9]*$/.test(v) || 'Teléfono sólo debe contener números',
                ],
                email: [
                    v => (v.length == 0 || /.+@.+\..+/.test(v)) || 'Correo debe ser con formato válido',
                ],
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        this.index()
    },
	methods: {
		validate () {
			return this.$refs.form.validate()
        },
        index(){
            this.loading = true
            this.$http.get(this.$store.state.apiRoute+'/clients/'+this.id+'/edit')
            .then((response) => {
                this.form = response.data
                this.form.phone = this.form.phone ?? ''
                this.form.ext_number = this.form.ext_number ?? ''
            })
            .catch(error => {
                error
            })
            .finally(() => {
                this.loading = false
            })
        },
        save(){
            this.$store.state.overlay = true

            if(this.validate()){               
                this.$http.put(this.$store.state.apiRoute+'/clients/'+this.id+'/update', this.form)
                .then((response) => {
                    response.data

                    this.$store.state.globalSnackbarProps.visible = true
                    this.$store.state.globalSnackbarProps.text = 'Se ha registrado correctamente el cliente <b>'+this.form.name+'</b>'
                    this.$router.push('/clientes')
                })
                .catch((error) => {
                    var errors = []
                    switch(error.response.status){
                        case 422: 
                            Object.keys(error.response.data.errors).forEach((x) => {
                                error.response.data.errors[x].forEach((y) => {
                                    errors.push(y)
                                })
                            })
                        break;
                        case 500: 
                            errors.push('Error en el servidor. Intente de nuevo.')
                        break;
                        case 404: 
                            errors.push('No encontrado.')
                        break;
                    }

                    this.snackbarProps = {
                        visible: true,
                        color: 'error',
                        timeout: 10000,
                        text: errors.join('.<br>'),
                    }
                })
                .finally(() => {
                    this.$store.state.overlay = false
                })
            }else{
                this.snackbarProps = {
                    visible: true,
                    color: 'error',
                    timeout: 2000,
                    text: 'Formulario incompleto',
                }

                this.$store.state.overlay = false
            }
            // eslint-disable-next-line no-console
        }
    },
}
</script>

<style>

</style>